module.exports = __webpack_public_path__ + "static/media/arrow_right_white.cd0b10dd.svg";